var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFnz = function SvgFnz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "100 100 291.85 100",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 114.286h50v8.673h-39.796v22.45h37.755v8.674h-37.755v31.631H100Zm107.757 34.183c0 11.123 0 15.92.51 22.45h-.408c-2.348-4.083-6.02-10.205-13.776-21.225l-24.591-35.408h-10.715v71.428h10.203v-34.183c0-11.123 0-15.918-.51-22.45h.408c2.347 4.082 6.021 10.205 13.776 21.226l24.592 35.407h10.714v-71.428h-10.203Zm73.199 28.572H239.12l40.306-54.082v-8.673h-51.531v8.673h39.286l-40.307 54.082v8.673h54.082ZM391.846 200h-100V100h100Zm-10.892-21.747h-78.216v6.25h78.216Z"
  })));
};

export default SvgFnz;